import { ActionType } from '../../constants/ActionTypes'

export default function withdrawReducer(state = {}, action) {
    switch (action.type) {

        // Get withdraw
        case ActionType.GET_WITHDRAW_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.GET_WITHDRAW_SUCCESS:
            return {
                ...state,
                inProcess: false,
                mainWithdraw: action.payload.Data
            };
        case ActionType.GET_WITHDRAW_FAILURE:
            return {
                ...state,
                inProcess: false,
                mainWithdraw: action.payload.Data,
            };

        // Get withdraw Details
        case ActionType.GET_WITHDRAW_DETAILS_BEGIN:
            return {
                ...state,
                details: {
                    inProcess: true,
                }
            };
        case ActionType.GET_WITHDRAW_DETAILS_SUCCESS:
            return {
                ...state,
                details: {
                    ...action.payload.Data,
                    inProcess: false,
                }
            };
        case ActionType.GET_WITHDRAW_DETAILS_FAILURE:
            return {
                ...state,
                details: {
                    ...state.withdraw.details,
                    inProcess: false,
                },
                error: action.payload
            };

        //Update Commissions
        case ActionType.UPDATE_WITHDRAW_BEGIN:
            return {
                ...state,
                inProcess: true
            };

        case ActionType.UPDATE_WITHDRAW_SUCCESS:
            return {
                ...state,
                withdraw: action.payload.withdraw,
                inProcess: false
            };

        case ActionType.UPDATE_WITHDRAW_FAILURE:
            return {
                ...state,
                inProcess: false,
                withdraw: {
                    ...state.withdraw,
                },
                error: action.payload
            };

        // Get sub withdraw
        case ActionType.GET_SUB_WITHDRAW_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.GET_SUB_WITHDRAW_SUCCESS:
            return {
                ...state,
                subWithdraw: action.payload.Data,
                inProcess: false,
            };

        case ActionType.GET_SUB_WITHDRAW_FAILURE:
            return {
                ...state,
                inProcess: false
            };

        // Create withdraw
        case ActionType.CREATE_WITHDRAW_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.CREATE_WITHDRAW_SUCCESS:
            return {
                ...state,
                inProcess: false,
                amount: action.payload.amount,
                bankName: action.payload.bankName,
                shebaNumber: action.payload.shebaNumber,
                accountNumber: action.payload.accountNumber,
                cardNumber: action.payload.cardNumber,
                name: action.payload.name,
            };

        case ActionType.CREATE_WITHDRAW_FAILURE:
            return {
                ...state,
                inProcess: false
            };

        // Create advance withdraw
        case ActionType.CREATE_ADVANCE_WITHDRAW_BEGIN:
            return {
                ...state,
                inProcess: true
            };
        case ActionType.CREATE_ADVANCE_WITHDRAW_SUCCESS:
            return {
                ...state,
                inProcess: false,
                ...action.payload,
            };

        case ActionType.CREATE_ADVANCE_WITHDRAW_FAILURE:
            return {
                ...state,
                inProcess: false
            };
        case ActionType.GET_WITHDRAWAL_TYPES_SUCCESS:
            return {
                ...state,
                inProcess: false,
                types: action.payload.Data,
            };  
        case ActionType.GET_WITHDRAWABLE_BALANCE_SUCCESS:
            return {
                ...state,
                inProcess: false,
                balance: action.payload.Data,
            };        
        default:
            return state;
    }
}



// WEBPACK FOOTER //
// ./src/reducers/mainAffilate/WithdrawReducer.js